import '_base.scss';
import '@cargomatic/ui/base.css';
import '@cargomatic/ui/fonts.css';
import '@cargomatic/ui/global.css';
import 'styles.css';
import './utils/sentry';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { Suspense } from 'react';
import Dom from 'react-dom';
import Command from 'components/command';
import LoadingCircle from 'components/ui/LoadingCircle';
import './i18n';
import { LocaleContextProvider } from './providers/locale-settings-context';
import LaunchDarklyWrapper from 'components/LaunchDarklyWrapper';
const queryClient = new QueryClient();
Dom.render(React.createElement(QueryClientProvider, { client: queryClient },
    React.createElement(Suspense, { fallback: React.createElement(LoadingCircle, null) },
        React.createElement(LaunchDarklyWrapper, null,
            React.createElement(LocaleContextProvider, null,
                React.createElement(Command, null))))), document.getElementById('content'));
